import { render, staticRenderFns } from "./vendorSingleOrder.vue?vue&type=template&id=62bd4bb9&scoped=true"
import script from "./vendorSingleOrder.vue?vue&type=script&lang=js"
export * from "./vendorSingleOrder.vue?vue&type=script&lang=js"
import style0 from "./vendorSingleOrder.vue?vue&type=style&index=0&id=62bd4bb9&prod&lang=scss&scoped=true"
import style1 from "./vendorSingleOrder.vue?vue&type=style&index=1&id=62bd4bb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bd4bb9",
  null
  
)

export default component.exports